<div class="pb-[60px] md:pb-[80px] lg:pb-[100px] xl:pb-[150px]">
    <div class="container 2xl:max-w-[1320px] mx-auto px-[12px] relative z-[1]">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-[25px] items-center">
            <div class="relative">
                <div class="md:max-w-[600px] lg:max-w-[400px] xl:max-w-[510px] p-[15px] md:p-[25px] md:p-[30px] xl:py-[27px] xl:px-[34px] rounded-[7px] bg-white/[.54] dark:bg-black/[.54] border border-white/[.10] dark:border-black/[.10] backdrop-blur-[5.400000095367432px]">
                    <img src="images/front-pages/image_1.png" class="inline-block" alt="order-summary-image">
                </div>
                <!-- <div class="absolute ltr:right-0 rtl:left-0 ltr:lg:right-[30px] rtl:lg:left-[30px] max-w-[120px] md:max-w-[200px] lg:max-w-[219px] -mt-[15px] md:-mt-[17px] rounded-[4.294px] top-1/2 -translate-y-1/2 drop-shadow-xl">
                <img src="images/front-pages/courses-sales.jpg" class="inline-block rounded-[4.294px]" alt="courses-sales-image">
            </div> -->
            </div>
            <div>
                <h2 class="!leading-[1.2] !text-xl md:!text-2xl lg:!text-[34px] xl:!text-4xl !mb-[15px] -tracking-[.5px] md:-tracking-[.6px] lg:-tracking-[.8px] xl:-tracking-[1px]">
                   <!--i18n: FXGS In brief -->
                    {{ 'i18n.app.features.pages.front-pages.common.fp-widgets.h2_01' | translate }} 
                </h2>
                <ul class="ltr:xl:pl-[18px] rtl:xl:pr-[18px] mt-[25px] md:mt-[30px] lg:mt-[35px] xl:mt-[65px]">
                    <li class="relative ltr:pl-[25px] rtl:pr-[25px] ltr:md:pl-[28px] rtl:md:pr-[28px] ltr:lg:pl-[30px] rtl:lg:pr-[30px] mb-[25px] xl:mb-[32px] last:mb-0">
                        <i class="material-symbols-outlined absolute text-primary-600 !text-[17px] md:!text-lg lg:!text-[20px] ltr:left-0 rtl:right-0 top-0 leading-none">
                            done_outline
                        </i>
                        <h3 class="!text-[15px] md:!text-md lg:!text-[17px] xl:!text-lg !mb-[8px] md:!mb-[10px] !font-semibold !leading-[1.2]">
                            <!--i18n: Who? -->
                            {{ 'i18n.app.features.pages.front-pages.common.fp-widgets.h3_01' | translate }} 
                        </h3>
                        <p class="!leading-[1.6] md:max-w-[458px] text-gray-500">
                            <!--i18n: Tourism and business travel. -->
                            {{ 'i18n.app.features.pages.front-pages.common.fp-widgets.p_01' | translate }}
                        </p>
                    </li>
                    <li class="relative ltr:pl-[25px] rtl:pr-[25px] ltr:md:pl-[28px] rtl:md:pr-[28px] ltr:lg:pl-[30px] rtl:lg:pr-[30px] mb-[25px] xl:mb-[32px] last:mb-0">
                        <i class="material-symbols-outlined absolute text-primary-600 !text-[17px] md:!text-lg lg:!text-[20px] ltr:left-0 rtl:right-0 top-0 leading-none">
                            done_outline
                        </i>
                        <h3 class="!text-[15px] md:!text-md lg:!text-[17px] xl:!text-lg !mb-[8px] md:!mb-[10px] !font-semibold !leading-[1.2]">
                            <!--i18n: What? -->
                            {{ 'i18n.app.features.pages.front-pages.common.fp-widgets.h3_02' | translate }} 
                        </h3>
                        <p class="!leading-[1.6] md:max-w-[458px] text-gray-500">
                            <!--i18n: All currencies, gold for storage, investment or collection. -->
                            {{ 'i18n.app.features.pages.front-pages.common.fp-widgets.p_02' | translate }}
                        </p>
                    </li>
                    <li class="relative ltr:pl-[25px] rtl:pr-[25px] ltr:md:pl-[28px] rtl:md:pr-[28px] ltr:lg:pl-[30px] rtl:lg:pr-[30px] mb-[25px] xl:mb-[32px] last:mb-0">
                        <i class="material-symbols-outlined absolute text-primary-600 !text-[17px] md:!text-lg lg:!text-[20px] ltr:left-0 rtl:right-0 top-0 leading-none">
                            done_outline
                        </i>
                        <h3 class="!text-[15px] md:!text-md lg:!text-[17px] xl:!text-lg !mb-[8px] md:!mb-[10px] !font-semibold !leading-[1.2]">
                            <!--i18n: Where? -->
                            {{ 'i18n.app.features.pages.front-pages.common.fp-widgets.h3_03' | translate }} 
                        </h3>
                        <p class="!leading-[1.6] md:max-w-[458px] text-gray-500">
                            <!--i18n: Tourist centers (hotels, cruise ships, casinos, etc.), business districts, border areas. -->
                            {{ 'i18n.app.features.pages.front-pages.common.fp-widgets.p_03' | translate }}
                        </p>
                    </li>
                    <li class="relative ltr:pl-[25px] rtl:pr-[25px] ltr:md:pl-[28px] rtl:md:pr-[28px] ltr:lg:pl-[30px] rtl:lg:pr-[30px] mb-[25px] xl:mb-[32px] last:mb-0">
                        <i class="material-symbols-outlined absolute text-primary-600 !text-[17px] md:!text-lg lg:!text-[20px] ltr:left-0 rtl:right-0 top-0 leading-none">
                            done_outline
                        </i>
                        <h3 class="!text-[15px] md:!text-md lg:!text-[17px] xl:!text-lg !mb-[8px] md:!mb-[10px] !font-semibold !leading-[1.2]">
                             <!--i18n: Why? -->
                            {{ 'i18n.app.features.pages.front-pages.common.fp-widgets.h3_04' | translate }} 
                        </h3>
                        <p class="!leading-[1.6] md:max-w-[458px] text-gray-500">
                            <!--i18n: Currencies: a universal, ubiquitous, accessible, and secure means of payment. Gold: a way to balance investment portfolios, a passion for collectors. -->
                            {{ 'i18n.app.features.pages.front-pages.common.fp-widgets.p_04' | translate }}
                        </p>
                    </li>
                </ul>
            </div>
        </div>

        <!-- shape :  Tache floue bas droite -->
        <div class="absolute -z-[1] ltr:-right-[30px] rtl:-left-[30px] bottom-[50px] blur-[150px]
                   bg-secondary-400/[0.25] dark:bg-primary-100/[0.25] rounded-full
                   w-[380px] h-[380px]">
        </div>

        <!-- shape : Tache floue haut (remplace shape8) -->
        <div class="absolute -z-[1] ltr:left-[250px] rtl:left-[260px] top-[265px] blur-[175px]
                   bg-secondary-400/[0.25] dark:bg-primary-100/[0.25] rounded-full
                   w-[420px] h-[340px]">
        </div>


        <div class="absolute -top-[60px] ltr:left-[65px] rtl:right-[65px] -z-[1] blur-[150px]">
            <img src="images/front-pages/shape7.png" alt="shape7">
        </div>
        <div class="absolute -bottom-[30px] ltr:right-[20px] rtl:left-[20px] -z-[1] blur-[125px]">
            <img src="images/front-pages/shape8.png" alt="shape8">
        </div>
    </div>
</div>
